import { render, staticRenderFns } from "./SimpleRepairPlanCommentsPage.vue?vue&type=template&id=9c0627f8&"
import script from "./SimpleRepairPlanCommentsPage.vue?vue&type=script&lang=ts&"
export * from "./SimpleRepairPlanCommentsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports